







import Vue from 'vue'
import OwnerNewAccessCode from '@/components/owner/OwnerNewAccessCode.vue'
import OwnerAccessCodeList from '@/components/owner/OwnerAccessCodeList.vue'

export default Vue.extend({
  name: 'OwnerAccessCodes',
  components: { OwnerNewAccessCode, OwnerAccessCodeList },
  data() {
    return {
      restaurantId: this.$router.currentRoute.params.restaurantId,
    }
  },
  methods: {},
})
